import React, { useState, useEffect } from "react";
import AddProjectForm from "./AddProjectForm";
import ExistingProject from "./ExistingProject";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Paper,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
  createProjectThunk,
  getProjectByIdentifiersThunk,
  updateProjectThunk,
} from "../redux/topicReducer";
import { closeProjectPopup } from "../redux/topicSlice";

export default function AllProjects() {
  const [activeTab, setActiveTab] = useState("existing");
  const { popupInfo, projectData } = useSelector((state) => state.topic);

  console.log("projectData", projectData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (popupInfo) {
      const filters = {
        chapter: popupInfo.chapter,
        period_number: popupInfo.period_number,
        subject_id: popupInfo.subject_id,
        class_id: popupInfo.class_id,
        section_id: popupInfo.section_id,
        teacher_id: popupInfo.teacher_id,
      };
      dispatch(getProjectByIdentifiersThunk(filters));
    }
  }, [popupInfo, dispatch]);
  useEffect(() => {
    if (projectData?.length > 0) {
      if (projectData[0].is_old === "1") {
        setActiveTab("existing");
      } else if (projectData[0].is_old === "2") {
        setActiveTab("add");
      }
    }
  }, [projectData]);

  const createPayload = (details, is_old) => ({
    chapter_name: popupInfo.chapter,
    period_number: popupInfo.period_number,
    subject_id: popupInfo.subject_id,
    class_id: popupInfo.class_id,
    teacher_id: popupInfo.teacher_id,
    section_id: popupInfo.section_id,
    school_id: 1,
    details,
    is_old,
  });

  const handleAddProject = async (newProjectDetails) => {
    const payload = createPayload(newProjectDetails, 2);
    console.log("📌 New Project Payload:", payload);
    if (projectData && projectData.length > 0) {
      const projectId = projectData[0].id;
      console.log("projectId", projectId);
      dispatch(updateProjectThunk({ id: projectId, details: payload.details }))
        .unwrap()
        .then(() => {
          alert("Project updated successfully!");
          dispatch(closeProjectPopup());
        })
        .catch((error) => {
          console.error("Failed to update remarks:", error);
        });
    } else {
      dispatch(createProjectThunk(payload))
        .unwrap()
        .then(() => {
          alert("✅ New Project Created");
          dispatch(closeProjectPopup());
        })
        .catch((error) => {
          console.error("❌ Error creating project:", error);
        });
    }
  };

  const handleExistingSubmit = async (selectedProjects) => {
    const details = JSON.stringify(selectedProjects);
    const payload = createPayload(details, 1);
    console.log("📌 Existing Project Payload:", payload);
    if (projectData && projectData.length > 0) {
      const projectId = projectData[0].id;
      console.log("projectId", projectId);
      dispatch(updateProjectThunk({ id: projectId, details: payload.details }))
        .unwrap()
        .then(() => {
          alert("Project updated successfully!");
          dispatch(closeProjectPopup());
        })
        .catch((error) => {
          console.error("Failed to update remarks:", error);
        });
    } else {
      dispatch(createProjectThunk(payload))
        .unwrap()
        .then(() => {
          alert("✅ Existing Projects Submitted");
          dispatch(closeProjectPopup());
        })
        .catch((error) => {
          console.error("❌ Error creating existing project:", error);
        });
    }
  };

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      {/* Radio Buttons */}
      <Paper
        sx={{
          width: "100%",
          p: 1,
          mb: 2,
          display: "flex",
          justifyContent: "flex-start",
          backgroundColor: "#f8f9fa",
          borderRadius: 1,
          boxShadow: "none",
        }}
      >
        <RadioGroup
          row
          value={activeTab}
          onChange={(e) => setActiveTab(e.target.value)}
          sx={{ fontSize: "14px" }}
        >
          <FormControlLabel
            value="existing"
            control={<Radio size="small" color="primary" />}
            label={<Typography fontSize="14px">Existing Projects</Typography>}
            disabled={projectData?.length > 0 && projectData[0].is_old === "2"}
          />

          <FormControlLabel
            value="add"
            control={<Radio size="small" color="primary" />}
            label={<Typography fontSize="14px">Add New Project</Typography>}
            disabled={projectData?.length > 0 && projectData[0].is_old === "1"}
          />
        </RadioGroup>
      </Paper>

      {/* Content */}
      <Paper sx={{ width: "100%", p: 2, borderRadius: 1, boxShadow: 1 }}>
        {activeTab === "existing" && (
          <ExistingProject
            onSubmit={handleExistingSubmit}
            projectData={projectData}
          />
        )}
        {activeTab === "add" && (
          <AddProjectForm
            onAddProject={handleAddProject}
            projectData={projectData}
          />
        )}
      </Paper>
    </Box>
  );
}
